<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Bon cadeau</h1>
                    <p>Gestion des coupons de connexion</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.giftcard.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un bon cadeau</span>
                </li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabs" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Montant', value:'value'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <span>Crédits restants</span>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Token', value:'token'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <span>Téléchargement</span>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'published', value:'publication_state_id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.giftcard.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                              <icon name="gift-01"/>
                            </figure>
                        </div>
                        <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                        <div data-field="name">
                          <strong class="highlight">{{ item.name }}</strong>
                          <div v-if="item.has_order > 0">
                            <span class="label published">auto-généré par une commande</span>
                          </div>
                        </div>
                        <div data-field="value">
                          <span class="price"><i>{{ $store.state.scope.currency_id }}</i> {{ item.value|formatNumber }}</span>
                        </div>
                        <div>
                          <span class="price"><i>{{ $store.state.scope.currency_id }}</i> {{ item.credits|formatNumber }}</span>
                        </div>
                        <div data-field="token">
                          <strong class="token">{{ item.token.toUpperCase() }}</strong>
                        </div>
                      <div class="center"><a :href="item.download_link" target="_blank"><img :src="'/src/assets/images/file-pdf.png'" width="32"/></a></div>
                      <div><published v-model="item.published" :date-start="item.start_at" :date-end="item.end_at"></published></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                          <ul v-if="paginator.filter == 'only_trashed'">
                            <li v-if="$aclInterfaceValidator('weeboxshop.giftcard.delete',item.id)"><button @click="forceDelete(item.id)"><icon name="trash-01"/></button></li>
                            <li v-if="$aclInterfaceValidator('weeboxshop.giftcard.update',item.id)"><button @click="restore(item.id)"><i class="icon icon-icon_refresh"></i></button></li>
                          </ul>
                          <ul v-else>
                            <li v-if="$aclInterfaceValidator('weeboxshop.giftcard.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                            <li v-if="$aclInterfaceValidator('weeboxshop.giftcard.update', item.id) && item.parent_id === null"><button @click="duplicate(item.id)" title="Dupliquer"><icon name="copy-07"/></button></li>
                            <li v-if="$aclInterfaceValidator('weeboxshop.giftcard.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                          </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import GiftcardService from './GiftcardService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
              tabs: [
                {
                  slug: '',
                  name: 'En cours'
                },
                {
                  slug: 'only_trashed',
                  name: 'Corbeille'
                }
              ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return GiftcardService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/giftcard/Index.vue